import { useEffect, useState, useRef } from "react";
import useGetClientId from "../hooks/useGetClientId";
import {
  GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID,
  INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
} from "../api/apiPath";
import http from "../api/server";
import Toaster from "./common/Toaster";
import useGetCity from "../hooks/useGetCity";
import PhoneNumber from "./common/PhoneNumber";
import AutocompleteInput from "./common/AutocompleteInput";

const UpdateUser = (props) => {
  const { entriesData, setShowEditMember } = props;
  // const entriesData = [
  //   {
  //     active: true,
  //     cityId: 2,
  //     cityName: "Manchester",
  //     fullName: "2 2",
  //     id: 2,
  //     phoneNumber: "919598265300",
  //     roleId: 1,
  //     roleName: "Admin",
  //     userEmail: "2@gmail.com",
  //     userId: 107,
  //     userStatus: "Active",
  //     userType: "Contractor",
  //     firstName: "shubham",
  //     lastName: "singh",
  //   },
  // ];
  const [allRoles, setAllRoles] = useState(null);
  const [city, setCity] = useState(null);
  const clientObj = useGetClientId();
  const cityObj = useGetCity();
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [validationFlag, setValidationFlag] = useState(false);
  const [archiveValidation, setArchiveValidation] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [noChangesFlag, setNoChangesFlag] = useState(false);

  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);
  console.log(cityObj);
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  console.log("entriesData", entriesData);

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID + "?clientId=" + clientId
      );
      if (response.status === 200) {
        setAllRoles(response.data.roles);
        console.log("roleId", response.data.roles);
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (clientObj.clientId) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const [entries, setEntries] = useState(entriesData);
  const handleChange = (id, field, value) => {
    if (field === "phoneNumber") {
      console.log("value", value);
      const rawNumber = value?.mobileNumber
        .replace(value?.mobileDialCode, "")
        .replace(/^\+/, "");
      const formattedNumber = `+${value?.mobileDialCode}-${rawNumber}` || "";
      setEntries(
        entries?.map((entry) =>
          entry.id === id ? { ...entry, [field]: formattedNumber } : entry
        )
      );
      console.log("formattedNumber", formattedNumber);
    } else {
      setEntries(
        entries?.map((entry) =>
          entry.id === id ? { ...entry, [field]: value } : entry
        )
      );
    }
  };

  const firstNameRef = useRef({});
  const lastNameRef = useRef({});
  const emailRef = useRef({});
  const phoneRef = useRef({});
  const typeRef = useRef({});
  const cityRef = useRef({});
  const roleRef = useRef({});

  const handleSave = (event) => {
    event.preventDefault();
    console.log(entries);
    if (!isDirty) {
      setNoChangesFlag(true);
      return;
    }
    setNoChangesFlag(false);
    let isValid = true;
    setValidationFlag(false);

    entries.forEach((entry) => {
      const fRef = firstNameRef.current[entry.id];
      if (!(entry.firstName ?? "").trim()) {
        if (fRef) fRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (fRef) fRef.style.border = "1px solid #ced4da";
      }

      const lRef = lastNameRef.current[entry.id];
      if (!(entry.lastName ?? "").trim()) {
        if (lRef) lRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (lRef) lRef.style.border = "1px solid #ced4da";
      }

      const eRef = emailRef.current[entry.id];
      if (
        !(entry.userEmail ?? "").trim() ||
        !isValidEmailOrMobile(entry.userEmail)
      ) {
        if (eRef) eRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (eRef) eRef.style.border = "1px solid #ced4da";
      }

      // if (!entry.phoneNumber) {
      //   const input = phoneRef.current[entry.id];
      //   if (input) {
      //     input.parentNode.style.border = "1px solid red";
      //   }
      // }

      const tRef = typeRef.current[entry.id];
      if (!(entry.userType ?? "").trim()) {
        if (tRef) tRef.className += " input-error";
        isValid = false;
      } else {
        if (tRef) tRef.className = "form-select";
      }

      const cRef = cityRef.current[entry.id];
      if (!(entry.cityId ?? "")) {
        if (cRef) {
          // inputRef in AutocompleteInput points directly to the input element
          cRef.style.border = "1px solid red";
          cRef.classList.add("input-error");
        }
        isValid = false;
      } else {
        if (cRef) {
          cRef.style.border = "1px solid #ced4da";
          cRef.classList.remove("input-error");
        }
      }

      const rRef = roleRef.current[entry.id];
      if (!(entry?.roleId ?? "")) {
        if (rRef) rRef.className += " input-error";
        isValid = false;
      } else {
        if (rRef) rRef.className = "form-select";
      }
    });

    if (!isValid) {
      setValidationFlag(true);
      return;
    }

    handleInviteUser();
  };

  const isValidEmailOrMobile = (value) => {
    // Email regex
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //.com or .in    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const additionalemailRegex = /^[^\s@]+@[^\s@]+\.(com|in|co\.in|co\.uk)$/;
    const valid = additionalemailRegex.test(value);
    return valid;
  };

  const handleInviteUser = async () => {
    console.log(entries);
    const payload = entries?.map((item) => ({
      clientId: clientObj.clientId,
      //propertyId: item?.propertyName?.value,
      roleId: item.roleId,
      userEmail: item.userEmail,
      firstName: item.firstName,
      lastName: item.lastName,
      cityId: item.cityId,
      userType: item.userType,
      userStatus: item.userStatus,
      phoneNumber: item.phoneNumber,
      HasRoleChanged:
        item.roleId !== entriesData.find((e) => e.id === item.id)?.roleId
          ? true
          : false,
      userId: item.userId,
      isMemberInvited: false,
    }));
    const finalPayload = {
      assignments: payload,
    };

    try {
      const response = await http.post(
        INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
        finalPayload
      );

      if (response.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Members are successfully invited",
        });
        setTimeout(() => {
          setShowEditMember(false);
        }, 2000);
        setEntries([
          {
            id: 1,
            userEmail: "",
            roleId: "",
            propertyName: "",
            firstName: "",
            lastName: "",
            phoneNumber: "",
            userType: "",
            userStatus: "",
            city: "",
            cityId: "",
          }, // Initial entry
        ]);
      }

      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
    } catch (error) {
      if (error.status === 400) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: error?.data?.title,
        });
      }
    }
  };

  //const [propertyCity, setPropertyCity] = useState(editPropertyDetails?.city);

  return (
    <>
      <div className="d-flex dashboard_body flex-column py-1 w-100">
        <div className="dashboard_header mt-3">
          <h2 className="mb-0">Update Member</h2>
          <div className="d-flex flex-row justify-content-between">
            <p className="header-description">Edit and update member details</p>
          </div>
        </div>
        <div >
          
            {entries?.map((entry) => (
              // eslint-disable-next-line react/jsx-key,
              <>
                <div  className="resident-card d-flex flex-column gap-2 mt-3 text-start">
                  <div
                    className="card-body-section"
                  >
                    <div className="form-group">
                      <label htmlFor="firstname">
                        First Name
                        <span className="label-star">*</span>
                      </label>
                      <input
                        type="text"
                        maxLength="50"
                        id="firstname"
                        required
                        placeholder="First Name"
                        value={entry.firstName}
                        ref={(el) => (firstNameRef.current[entry.id] = el)}
                        onChange={(e) => {
                          handleChange(entry.id, "firstName", e.target.value);
                          setIsDirty(true);
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="floatingInput">
                        Last Name
                        <span className="label-star">*</span>
                      </label>
                      <input
                        type="lastname"
                        maxLength="50"
                        id="floatingInput"
                        placeholder="Last Name"
                        required
                        value={entry.lastName}
                        ref={(el) => (lastNameRef.current[entry.id] = el)}
                        onChange={(e) => {
                          handleChange(entry.id, "lastName", e.target.value);
                          setIsDirty(true);
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="floatingInput">
                        Email<span className="label-star">*</span>
                      </label>
                      <input
                        type="userEmail"
                        id="floatingInput"
                        placeholder="sample@example.com"
                        value={entry.userEmail}
                        ref={(el) => (emailRef.current[entry.id] = el)}
                        onChange={(e) => {
                          handleChange(entry.id, "userEmail", e.target.value);
                          setIsDirty(true);
                        }}
                        required
                      />
                    </div>
                    <div
                      className="form-group"
                    >
                      <label htmlFor="floatingInput">Mobile Number</label>
                      <PhoneNumber
                        setPhoneNumber={(e) => {
                          handleChange(entry.id, "phoneNumber", e);
                          setIsDirty(true);
                        }}
                        phoneNumber={{
                          mobileNumber: entry.phoneNumber,
                          mobileCountryCode: "",
                          mobileDialCode: "",
                        }}
                        inputRef={(el) => (phoneRef.current[entry.id] = el)}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor={`userType-${entry.id}`}>
                        User Type<span className="label-star">*</span>
                      </label>
                      <select
                        name="userType"
                        className="form-select"
                        id={`userType-${entry.id}`}
                        value={entry.userType || ""}
                        ref={(el) => (typeRef.current[entry.id] = el)}
                        onChange={(e) => {
                          handleChange(entry.id, "userType", e.target.value);
                          setIsDirty(true);
                        }}
                      >
                        <option value="">Select Type</option>
                        <option value="Internal Staff">Internal staff</option>
                        <option value="Contractor">Contractor</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor={`city-${entry.id}`}>
                        City<span className="label-star">*</span>
                      </label>
                      <AutocompleteInput
                        name="city"
                        // masterList= {city || []}
                         masterList={
                              [...(city || [])].sort((a, b) =>
                                (a.cityName || "").localeCompare(b.cityName || "", undefined, {
                                  sensitivity: "base",
                                })
                              )
                            }
                        className="form-select"
                        id={`city-${entry.id}`}
                        getOptionLabel={(c) => c?.cityName || ""}
                          getOptionValue={(c) => c?.cityId || ""}
                          placeholder="Select City"
                          inputClassName=""
                          wrapperClassName=""
                          notFoundText="City not found"
                        aria-label="Floating label select example"
                        value={entry.cityId}
                        inputRef={(el) => (cityRef.current[entry.id] = el)}
                        onValueChange={(val) => {
                          handleChange(entry.id, "cityId", val);
                          setIsDirty(true);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor={`roleId-${entry.id}`}>
                        Role<span className="label-star">*</span>
                      </label>
                      <select
                        name="roleId"
                        className="form-select"
                        id={`roleId-${entry.id}`}
                        aria-label="Floating label select example"
                        value={entry.roleId}
                        ref={(el) => (roleRef.current[entry.id] = el)}
                        onChange={(e) => {
                          handleChange(entry.id, "roleId", e.target.value);
                          setIsDirty(true);
                        }}
                      >
                        <option value="">Select a Role</option>
                        {allRoles?.map((data) => (
                          <option key={data?.roleId} value={data?.roleId}>
                            {data.roleName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="floatingSelect">
                        Status
                        <span className="label-star">*</span>
                      </label>
                      <select
                        name="roleId"
                        className="form-select"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={entry.userStatus}
                        onChange={(e) => {
                          handleChange(entry.id, "userStatus", e.target.value);
                          setArchiveValidation(true);
                          setIsDirty(true);
                        }}
                      >
                        <option value="active">Active</option>
                        <option value="archived">Archived</option>
                      </select>
                       <div className="d-flex mt-1" style={{ textAlign: "justify" }}>
                          {entry.userStatus === "archived" &&
                            archiveValidation && (
                              <div
                                className="text-danger "
                                style={{ fontSize: "13px" }}
                              >
                                <p>
                                  Are you sure you want to archive this member?
                                  Please ensure that the user is not part of any
                                  active inspections from the Inspection Dashboard
                                  before proceeding with the update.
                                </p>
                              </div>
                            )}
                    </div>
                    </div>                   
                  </div>
                </div>
              </>
            ))}
          
        </div>
        <div className="mt-1">
          {" "}
          {validationFlag && (
            <small style={{ color: "red" }}>
              * Please fill all required fields with valid details
            </small>
          )}
          {noChangesFlag && !isDirty && (
            <small style={{ color: "red" }}>
              No changes detected to update
            </small>
          )}
        </div>

        <div className="button-container">
          <button
            type="submit"
            className="btn-primary col-sm-5 col-md-2"
            onClick={handleSave}
            style={{
              marginRight: "10px",
            }}
          >
            Update Member
          </button>
          <button
            type="button"
            className="btn-secondary col-sm-5 col-md-2"
            onClick={() => setShowEditMember(false)}
          >
            Cancel
          </button>
          
        </div>

        <Toaster
          show={toastData.toastShow}
          toastType={toastData.toastType}
          title={toastData.toastString}
          theme={"dark"}
          position="top-center"
          closeButton={() => {
            closeButton();
          }}
        />
        {/* </div> */}
        {/* </div> */}
      </div>
    </>
  );
};
export default UpdateUser;
